'use client';
import { signOut } from 'next-auth/react';

interface DashboardHeaderProps {
  date: string;
  branch: string;
  leader: string;
  userName: string;
  onDateChange: (date: string) => void;
  onBranchChange: (branch: string) => void;
  onLeaderChange: (leader: string) => void;
}

const BRANCHES = ['All', 'Des Moines', 'Kansas City', 'Omaha'];
const LEADERS_BY_BRANCH: Record<string, string[]> = {
  'All': ['All', 'Austin', 'Brandon', 'Chris', 'Derek', 'Jake', 'Jordan', 'Matt', 'Nick', 'Ryan', 'Tyler'],
  'Des Moines': ['All', 'Austin', 'Brandon', 'Matt', 'Tyler'],
  'Kansas City': ['All', 'Chris', 'Derek', 'Nick'],
  'Omaha': ['All', 'Jake', 'Jordan', 'Ryan'],
};

export default function DashboardHeader({ date, branch, leader, userName, onDateChange, onBranchChange, onLeaderChange }: DashboardHeaderProps) {
  const leaders = LEADERS_BY_BRANCH[branch] || LEADERS_BY_BRANCH['All'];

  return (
    <header className="bg-gradient-to-r from-[#D86018] to-[#c44f0e] shadow-md">
      <div className="max-w-[1600px] mx-auto px-4 py-3">
        <div className="flex flex-wrap items-center gap-4">
          {/* Logo + Title */}
          <div className="flex items-center gap-3 mr-auto">
            <img src="/miller-logo.png" alt="Miller Pest" className="h-9 w-auto rounded" />
            <h1 className="text-white font-bold text-lg hidden sm:block">Miller Proof Operations Dashboard</h1>
            <h1 className="text-white font-bold text-base sm:hidden">Miller Proof</h1>
          </div>

          {/* Filters */}
          <div className="flex flex-wrap items-center gap-2">
            <input
              type="date"
              value={date}
              onChange={e => onDateChange(e.target.value)}
              className="px-3 py-1.5 rounded-lg text-sm bg-white/90 border-0 focus:ring-2 focus:ring-white/50"
            />
            <select
              value={branch}
              onChange={e => { onBranchChange(e.target.value); onLeaderChange('All'); }}
              className="px-3 py-1.5 rounded-lg text-sm bg-white/90 border-0 focus:ring-2 focus:ring-white/50"
            >
              {BRANCHES.map(b => <option key={b} value={b}>{b === 'All' ? 'All Branches' : b}</option>)}
            </select>
            <select
              value={leader}
              onChange={e => onLeaderChange(e.target.value)}
              className="px-3 py-1.5 rounded-lg text-sm bg-white/90 border-0 focus:ring-2 focus:ring-white/50"
            >
              {leaders.map(l => <option key={l} value={l}>{l === 'All' ? 'All Leaders' : l}</option>)}
            </select>
          </div>

          {/* User */}
          <div className="flex items-center gap-2">
            <span className="text-white/90 text-sm hidden md:block">{userName}</span>
            <button
              onClick={() => signOut({ callbackUrl: '/login' })}
              className="px-3 py-1.5 bg-white/20 hover:bg-white/30 text-white rounded-lg text-sm transition-colors"
            >
              Sign Out
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
